<template>
  <v-container fluid grid-list-md style="padding: 20px;">
    <v-row dense v-if="user.tipo == 'ADMIN'">
      <v-col cols="12" sm="6" md="6">
        <v-select
          outlined
          dense
          v-model="empresaSelecionada"
          :items="empresas"
          item-text="nome"
          item-value="id"
          label="Selecione a empresa"
          @input="carregaConsumidores(empresaSelecionada);"
          class="mr-2"
        ></v-select>
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <v-tooltip bottom v-if="empresaTemActiveSoft">
          <template v-slot:activator="{ on }">
            <v-btn @click="atualizarConsumidores" fab small v-on="on" color="primary" depressed :loading="isLoading" :disabled="isLoading">
              <v-icon>refresh</v-icon>
            </v-btn>
          </template>
          <span>Atualizar Consumidores com Active Soft</span>
        </v-tooltip>

        <v-tooltip bottom v-if="user.tipo == 'ADMIN'">
          <template v-slot:activator="{ on }">
            <v-btn @click="dialogoTransferencia = true" fab small v-on="on" color="yellow" depressed class="ml-3" :loading="isLoading" :disabled="user.tipo == 'ADMIN' ? !empresaSelecionada : isLoading">
              <v-icon>mdi-transfer</v-icon>
            </v-btn>
          </template>
          <span>Transferir consumidores</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" v-if="empresaSelecionada">
        <v-alert type="info">
          Use o link de cadastro para que os pais e responsáveis façam o cadastro dos alunos.
          <br>
          <v-btn outlined @click="copiarTexto('https://aiconsumer.com.br/cadastro?s=' + subdominioSelecionado)" :disabled="mensagemCopiado">
            {{ !mensagemCopiado ? 'Copiar link ' : 'Copiado!' }}
          </v-btn>
        </v-alert>
      </v-col>

      <v-col cols="12" sm="12" md="12">
        <v-data-table
          :search="tabela.busca"
          :headers="tabela.cabecalho"
          :items="tabela.conteudo"
          sort-by="titulo"
          class="elevation-1 consumidores-table"
          style="border-radius: 10px;"
          :footer-props="{
            'items-per-page-text': 'Linhas por página',
            'items-per-page-all-text': 'Tudo',
          }"
          :loading="tabela.carregamento"
          loading-text="Buscando itens..."
        >
          <template v-slot:top>
            <v-toolbar flat color="white" style="border-radius: 10px;">
              <v-toolbar-title class="textoUser">CONSUMIDORES</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field v-model="tabela.busca" append-icon="search" label="Procurar" single-line hide-details></v-text-field>
              <v-spacer></v-spacer>
              <v-btn text @click="dialogoConsumidor = true" tile color="#3BA8A2" :disabled="user.tipo == 'ADMIN' ? !empresaSelecionada : false">
                <v-icon left dark>add_circle</v-icon>Cadastrar
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-tooltip bottom v-if="user.tipo === 'ADMIN' || user.tipo === 'ADMIN_PRODUTORA'">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon @click="editItem(item)" color="#01579B">mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom v-if="user.tipo === 'ADMIN' || user.tipo === 'ADMIN_PRODUTORA'">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon @click="deleteItem(item)" color="#FF0000">mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Excluir</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" :disabled="!item.qrCode">
                  <v-icon @click="dialogoValorTransacao = true; tipoTransacao = 'PIX'; editedItem = item" color="#01579B">mdi-cash-plus</v-icon>
                </v-btn>
              </template>
              <span>Recarga</span>
            </v-tooltip>
            <v-tooltip bottom v-if="podeAdminSaldoCartao && item.qrCode">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" @click="abrirDialogoAdminAjusteSaldo(item)">
                  <v-icon color="#6A1B9A">mdi-scale-balance</v-icon>
                </v-btn>
              </template>
              <span>Ajustar saldo (admin)</span>
            </v-tooltip>
            <v-tooltip bottom v-if="podeAdminSaldoCartao && item.qrCode">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" @click="abrirDialogoAdminTransferenciaSaldo(item)">
                  <v-icon color="#4527A0">mdi-bank-transfer-out</v-icon>
                </v-btn>
              </template>
              <span>Transferir saldo para outro cartão</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon @click="reenviarBoasVindas(item)" color="#009688">mdi-message-arrow-right-outline</v-icon>
                </v-btn>
              </template>
              <span>Reenviar Boas-Vindas</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon @click="reenviarSenha(item)" color="#9E9D24">mdi-send-lock</v-icon>
                </v-btn>
              </template>
              <span>Reenviar Senha</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.senha`]="{ item }">
            {{ item.senha != '' ? "****" : item.senha}}
          </template>
          <template v-slot:no-data>
            <v-row>
              <v-col>
                <v-alert dark dense text outlined color="warning" icon="info" style="margin: 0px">Nenhum usuário cadastrado</v-alert>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogoConsumidor" persistent max-width="500px" scrollable>
      <v-card>
        <v-card-title>{{ formTitle }}</v-card-title>
        <v-card-subtitle>* indica preenchimento obrigatório</v-card-subtitle>
        <v-card-text style="padding-bottom: 0px">
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-text-field label="Nome*" outlined dense hide-details v-model="editedItem.nome"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-text-field label="CPF" outlined dense hide-details v-model="editedItem.cpf" v-validate="'required|cpf'" :error-messages="errors.collect('cpf')" data-vv-name="cpf" type="tel" v-mask="'###.###.###-##'"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-text-field label="WhatsApp com DDD*" outlined dense v-model="editedItem.whatsApp" v-mask="'(##) #####-####'" persistent-hint hint="As notificações serão enviadas para o número informado" type="tel"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-text-field label="Nascimento" outlined dense hide-details v-model="editedItem.dataNascimento"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-text-field label="Senha*" outlined dense hide-details v-model="editedItem.senha"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-text-field label="Matricula*" outlined dense hide-details v-model="editedItem.matricula"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-text-field label="Turma*" outlined dense hide-details v-model="editedItem.turma"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-text-field label="Curso*" outlined dense hide-details v-model="editedItem.curso"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-text-field label="Responsável*" outlined dense hide-details v-model="editedItem.responsavel"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12" v-if="editedIndex != -1">
              <v-text-field
                label="QR Code"
                outlined
                dense
                hide-details
                :value="editedItem.qrCode"
                @input="editedItem.qrCode = $event ? $event.toUpperCase() : ''"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-card outlined>
                <v-card-title style="padding: 10px 16px 10px 16px">Foto</v-card-title>
                <v-card-text style="padding: 0px">
                  <v-img
                    v-if="editedItem.hashBase64 || editedItem.foto"
                    :src="editedItem.hashBase64 || editedItem.foto"
                    contain
                    width="100%"
                    height="100%"
                  ></v-img>
                  <v-alert
                    v-if="!editedItem.hashBase64 && !editedItem.foto"
                    type="info"
                    style="margin: 0px"
                  >
                    <p>Nenhuma foto</p>
                    <v-btn outlined @click="dialogoCamera = true">Capturar Foto</v-btn>
                    <br>
                    <file-upload
                      class="btn btn-primary mt-1"
                      input-id="file1"
                      extensions="png,gif,jpeg,jpg"
                      accept="image/png,image/gif,image/jpeg,image/jpg"
                      post-action="/upload/post"
                      v-model="filesRg1"
                      @input-filter="inputFilter"
                      @input-file="inputFileRg1"
                      ref="upload1"
                    >
                      <v-btn outlined>Selecionar Foto</v-btn>
                      <p id="foto" value="" hidden></p>
                    </file-upload>
                  </v-alert>
                </v-card-text>
                <v-card-actions v-if="(editedItem.hashBase64 || editedItem.foto)">
                  <v-row dense>
                    <v-col cols="12">
                      <v-btn text @click="dialogoCamera = true" color="primary">Capturar Outra</v-btn>
                    </v-col>
                    <v-col cols="12">
                      <file-upload
                        class="btn btn-primary"
                        input-id="file1"
                        extensions="png,gif,jpeg,jpg"
                        accept="image/png,image/gif,image/jpeg,image/jpg"
                        post-action="/upload/post"
                        v-model="filesRg1"
                        @input-filter="inputFilter"
                        @input-file="inputFileRg1"
                        ref="upload1"
                      >
                        <v-btn color="primary" text>Selecionar Outra</v-btn>
                        <p id="foto" value="" hidden></p>
                      </file-upload>
                    </v-col>
                    <v-col cols="12" v-if="editedIndex == -1">
                      <v-btn color="error" @click="editedItem.hashBase64 = ''" text>Remover</v-btn>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click="dialogoConsumidor = false">Fechar</v-btn>
          <v-btn text color="success" @click="salvarConsumidor" v-if="editedIndex == -1">Salvar</v-btn>
          <v-btn text color="success" @click="editarConsumidor" v-if="editedIndex != -1">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogoCamera" max-width="500px">
      <v-card>
        <v-card-title style="padding: 5px 15px 5px 15px">
          Câmera
          <v-spacer></v-spacer>
          <v-btn @click="dialogoCamera = false" icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="padding: 0px">
          <CameraView
            ref="camera"
            :ativo="dialogoCamera"
            @cameras-detectadas="totalCameras = $event"
          />

          <div align="center" justify="center" style="padding-bottom: 8px">
            <v-btn
              v-if="totalCameras > 1"
              @click="$refs.camera.alternarCamera()"
              fab
              dark
              class="mr-3"
            >
              <v-icon large>mdi-camera-flip</v-icon>
            </v-btn>
            <v-btn @click="capturarFoto" fab dark>
              <v-icon large>mdi-camera-iris</v-icon>
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- DIALOGO VALOR TRANSAÇÃO -->
    <v-dialog v-model="dialogoValorTransacao" persistent max-width="300px">
        <v-card>
          <v-card-title></v-card-title>
          <v-card-text style="padding-bottom: 0px">
            <v-row dense>
              <p>Informe o valor que deseja recarregar. Valor mínimo para recargas: R$1,00.</p>
              <v-col cols="12">
                <v-text-field label="Valor" outlined v-model="valorTransacao" hide-details v-money="money" prefix="R$" type="tel" color="#474d55" dense id="campoValor"></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="success" v-if="tipoTransacao == 'PIX'" @click="abreLeituraQRCode()">Continuar</v-btn>
            <v-btn text color="red" @click="dialogoValorTransacao = false">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOGO QRCODE -->
      <v-dialog v-model="dialogoPagamentoPix" persistent max-width="600px">
        <v-card>
          <v-card-title>Pagamento</v-card-title>
          <v-card-text style="text-align: center; padding-bottom: 0px">
            <v-container>
              <v-row align="center" justify="center">
                <v-col cols="12" style="padding: 10px">
                  <p class="texto" style="text-align: left; font-weight: bold;">
                    Copie este código para pagar <b style="color: green">R$ {{valorTransacao}}</b>:
                  </p>
                  <ol style="text-align: left; padding-left: 16px; margin: 0;">
                    <li>Acesse seu app de pagamentos.</li>
                    <li>Escolha pagar via Pix.</li>
                    <li>Cole o seguinte código:</li>
                  </ol>
                </v-col>
              </v-row>
              <v-row align="center" justify="center">
                <v-col cols="12" style="padding: 1px">
                  <v-card flat color="#ffffff">
                    <qrcode-vue v-if="exibirQRCode && gatewayPagamento == 'SICOOB'" :value="cobrancaPix.qrCode" :size="200" level="H" bg-color="white"></qrcode-vue>
                    <qrcode-vue v-if="exibirQRCode && gatewayPagamento == 'ASSAS'" :value="cobrancaPix.qrCode" :size="200" level="H" bg-color="white"></qrcode-vue>
                    <qrcode-vue v-if="exibirQRCode && gatewayPagamento == 'TAPAGO'" :value="cobrancaPix.qrCode" :size="200" level="H" bg-color="white"></qrcode-vue>
                  </v-card>
                </v-col>
              </v-row>
              <v-row align="center" justify="center">
                <v-col cols="12" style="padding: 1px;">
                  <p class="texto" style="color: #073478" v-if="gatewayPagamento == 'ASSAS'">Nome Fantasia: INTELITE TECNOLOGIA</p>
                  <p class="texto" style="color: #00695C" v-if="gatewayPagamento == 'TAPAGO'">Nome Fantasia: INTELITE TECNOLOGIA FLAGSHIP</p>
                </v-col>
                <v-col cols="12" style="padding: 1px; position: absolute; left: -99999px;">
                  <v-text-field id="chavePix" v-model="cobrancaPix.chaveCopiaCola"></v-text-field>
                </v-col>
              </v-row>
            </v-container>
            <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="12" md="12" style="padding: 10px 0px 10px 0px">
                    <v-text-field
                      v-model="cobrancaPix.chaveCopiaCola"
                      label="Chave Pix Copia e Cola"
                      id="chavePix"
                      outlined
                      readonly
                      dense
                      disable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="4" style="padding-top: 0;">
                    <v-btn
                      color="#073478"
                      dark
                      depressed
                      @click="doCopy('chavePix')"
                      style="border-radius: 10px; font-weight: bold;"
                    >
                      Copiar código
                    </v-btn>
                  </v-col>
                  <v-col cols="12" sm="12" md="4" style="padding-top: 0;">
                    <v-btn
                      color="#073478"
                      dark
                      depressed
                      @click="exibirQRCode = !exibirQRCode"
                      style="border-radius: 10px; font-size: 14px; "
                    >
                      {{ exibirQRCode ? 'Ocultar QR Code' : 'Exibir QR Code' }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn style="border-radius: 7px;" dark depressed block color="#073478" @click="closeDialog(false)">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogoConfirmacao" persistent max-width="400px">
        <v-card>
          <v-card-text style="text-align: center; padding-bottom: 0px">
            <v-container>
              <v-row align="center" justify="center">
                <v-col cols="12" style="padding-bottom: 0px;">
                  <v-icon color="success" size="100">check_circle</v-icon>
                </v-col>
                <v-col cols="12" style="padding: 2px;">
                  <p class="texto" style="color: #666; margin: 0px">Recarga realizada com sucesso!</p>
                  <p class="texto" style="color: #666; margin: 0px">Nome: {{ editedItem.nome }}</p>
                  <p class="texto" style="color: #666; margin: 0px" v-if="saldoCartao">Saldo: R$ {{saldoCartao}}</p>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="dialogoConfirmacao = false">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogoTransferencia" persistent max-width="600px">
        <v-card>
          <v-card-title>Transferência de consumidores</v-card-title>
          <v-card-text style="text-align: center; padding-bottom: 0px">
            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  light
                  multiple
                  hide-details
                  outlined
                  chips
                  clearable
                  v-model="transferencia.turmasSelecionadas"
                  :items="transferencia.turmasParaTransferir"
                  label="Turmas para transferir"
                >
                  <template v-slot:selection="data">
                    <v-chip
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      close
                      @click="data.select"
                      @click:close="remove(data.item)"
                    >
                      {{ data.item }}
                    </v-chip>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  light
                  hide-details
                  outlined
                  clearable
                  v-model="transferencia.empresaSelecionada"
                  :items="transferencia.empresasParaTransferir"
                  item-text="nome"
                  item-value="id"
                  label="Escola de destino"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="red" @click="dialogoTransferencia = false">Fechar</v-btn>
            <v-btn text color="primary" :disabled="transferencia.turmasSelecionadas.length == 0 || !transferencia.empresaSelecionada" @click="transferirAlunos">Transferir</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogoAdminAjusteSaldo" persistent max-width="440">
        <v-card>
          <v-card-title class="text-h6">Ajustar saldo (administrador)</v-card-title>
          <v-card-subtitle class="pb-0">{{ adminSaldo.consumidorNome }}</v-card-subtitle>
          <v-card-text>
            <v-select
              v-model="adminSaldo.operacao"
              :items="adminSaldoOpcoesOperacao"
              item-text="text"
              item-value="value"
              label="Tipo de ajuste"
              outlined
              dense
              hide-details
              class="mb-3"
            />
            <v-text-field
              v-model="adminSaldo.valorStr"
              label="Valor (R$)"
              outlined
              dense
              hint="Em «Definir saldo», informe o saldo final desejado no cartão."
              persistent-hint
            />
            <v-text-field
              v-model="adminSaldo.motivo"
              label="Motivo (opcional, recomendado)"
              outlined
              dense
              hide-details
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn text color="grey" @click="dialogoAdminAjusteSaldo = false">Cancelar</v-btn>
            <v-btn color="primary" depressed :loading="adminSaldo.loading" @click="executarAdminAjusteSaldo">Confirmar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogoAdminTransferenciaSaldo" persistent max-width="480">
        <v-card>
          <v-card-title class="text-h6">Transferir saldo entre cartões</v-card-title>
          <v-card-subtitle class="pb-0">Origem: {{ adminTransf.consumidorOrigem }}</v-card-subtitle>
          <v-card-text>
            <v-select
              v-model="adminTransf.destConsumidorId"
              :items="consumidoresDestinoAdmin"
              item-text="nome"
              item-value="id"
              label="Aluno destino"
              outlined
              dense
              hide-details
              class="mb-3"
              no-data-text="Nenhum outro consumidor na lista"
            />
            <v-text-field
              v-model="adminTransf.valorStr"
              label="Valor a transferir (R$)"
              outlined
              dense
              hide-details
              class="mb-3"
            />
            <v-text-field
              v-model="adminTransf.motivo"
              label="Motivo (opcional)"
              outlined
              dense
              hide-details
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn text color="grey" @click="dialogoAdminTransferenciaSaldo = false">Cancelar</v-btn>
            <v-btn color="primary" depressed :loading="adminTransf.loading" @click="executarAdminTransferenciaSaldo">Transferir</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    <Snackbar ref=chamaSnackbar />
    <loading :active.sync="isLoading" :can-cancel="false" color="#3BA8A2" :is-full-page="fullPage"></loading>
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  import { VMoney } from 'v-money'
  import moment from 'moment'
  import QrcodeVue from 'qrcode.vue'
  import FileUpload from 'vue-upload-component'
  import CameraView from '../componentes/CameraView.vue'

  export default {
    components: { Snackbar, Loading, QrcodeVue, FileUpload, CameraView, },
    data: () => ({
      cobrancaAsaas: {},
      isLoading: false,
      fullPage: true,
      lojistas: [],
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Nome', align: 'start', value: 'nome' },
          { text: 'CPF', value: 'cpf', width: '132px', cellClass: 'consumidor-cell-nowrap' },
          { text: 'WhatsApp', value: 'whatsApp', width: '148px', cellClass: 'consumidor-cell-nowrap' },
          { text: 'Matricula', value: 'matricula', width: '96px', cellClass: 'consumidor-cell-nowrap' },
          { text: 'Nascimento', value: 'dataNascimento', width: '112px', cellClass: 'consumidor-cell-nowrap' },
          { text: 'Turma', value: 'turma', width: '220px', cellClass: 'consumidor-cell-turma' },
          { text: 'Curso', value: 'curso', width: '160px', cellClass: 'consumidor-cell-curso' },
          { text: 'Responsável', value: 'responsavel', width: '200px', cellClass: 'consumidor-cell-responsavel' },
          { text: 'Senha', value: 'senha', width: '72px', cellClass: 'consumidor-cell-nowrap' },
          { text: 'Ações', value: 'action', sortable: false, align: 'center', width: '260px', cellClass: 'consumidor-cell-acoes' },
        ],
        carregamento: false,
        conteudo: [],
      },
      dialogoConsumidor: false,
      editedIndex: -1,
      editedItem: {
        nome: '',
        cpf: '',
        whatsApp: '',
        matricula: '',
        turma: '',
        curso: '',
        responsavel: '',
        senha: '',
        dataNascimento: '',
        hashBase64: '',
        qrCode: '',
      },
      defaultItem: {
        nome: '',
        cpf: '',
        whatsApp: '',
        matricula: '',
        turma: '',
        curso: '',
        responsavel: '',
        senha: '',
        dataNascimento: '',
        hashBase64: '',
        qrCode: '',
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      },
      dialogoValorTransacao: false,
      dialogoPagamentoPix: false,
      dialogoConfirmacao: false,
      dialogoTransferencia: false,
      exibirQRCode: false,
      gatewayPagamento: '',
      saldoCartao: '',
      valorTransacao: 0.00,
      tipoTransacao: '',
      formaTransacao: '',
      codigoQrCode: '',
      cobrancaPix: {
        id: '',
        qrCode: '',
        chaveCopiaCola: '',
      },
      empresas: [],
      empresaSelecionada: '',
      subdominioSelecionado: '',
      lojistaSelecionado: '',
      dialogoCamera: false,
      filesRg1: [],
      mensagemCopiado: false,
      totalCameras: 1,
      transferencia: {
        empresasParaTransferir: [],
        empresaSelecionada: '',
        turmasParaTransferir: [],
        turmasSelecionadas: [],
      },
      dialogoAdminAjusteSaldo: false,
      dialogoAdminTransferenciaSaldo: false,
      adminSaldoOpcoesOperacao: [
        { text: 'Acrescentar saldo', value: 'ACRESCENTAR' },
        { text: 'Subtrair saldo', value: 'SUBTRAIR' },
        { text: 'Definir saldo (valor final no cartão)', value: 'DEFINIR' },
      ],
      adminSaldo: {
        loading: false,
        cartaoId: '',
        consumidorNome: '',
        operacao: 'ACRESCENTAR',
        valorStr: '',
        motivo: '',
      },
      adminTransf: {
        loading: false,
        cartaoOrigemId: '',
        origemConsumidorId: '',
        consumidorOrigem: '',
        destConsumidorId: '',
        valorStr: '',
        motivo: '',
      },
    }),

    computed: mapState({
      ConsumidorLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitle () {
        return this.editedIndex === -1 ? 'Adicionar novo usuário' : 'Editar usuário'
      },
      
      empresaTemActiveSoft() {
        if (this.user.tipo == 'ADMIN') {
          if (!this.empresaSelecionada) return false
          const empresa = this.empresas.find(e => e.id === this.empresaSelecionada)
          return empresa && empresa.usaActiveSoft === true
        } else {
          return this.companyobj && this.companyobj.usaActiveSoft === true
        }
      },

      podeAdminSaldoCartao() {
        if (this.user.tipo !== 'ADMIN') return false
        return !!this.empresaSelecionada
      },

      consumidoresDestinoAdmin() {
        if (!this.adminTransf.origemConsumidorId || !this.tabela.conteudo) return []
        return this.tabela.conteudo.filter(
          (c) => c.id !== this.adminTransf.origemConsumidorId && c.qrCode
        )
      },
    }),

    watch: {
      dialogoConsumidor(val) {
        if (val == false) {
          setTimeout(() => {
            this.editedItem = Object.assign({}, this.defaultItem)
            this.editedIndex = -1
          }, 300);
        }
      },

      dialogoCamera(val) {
        if (val == true) {
          //
        } else {
          //
        }
      },

      dialogoTransferencia(val) {
        if (val) {
          this.transferencia.turmasParaTransferir = this.obterTurmasUnicas(this.tabela.conteudo)
          this.transferencia.empresasParaTransferir = this.empresas
        }
        else {
          setTimeout(() => {
            this.transferencia.turmasParaTransferir = []
            this.transferencia.turmasSelecionadas  = []
          }, 300);
        }
      },
    },

    mounted() {
      if (this.user.tipo == 'ADMIN') {
        this.carregaEmpresas()
      } else {
        this.carregaConsumidores()
      }
    },

    beforeDestroy() {
      //
    },

    methods: {
      async carregaEmpresas() {
        await axios.get(baseApiUrl + 'Empresas?filter={"order":"nome ASC", "fields":{"nome": true, "id": true, "subdominio": true, "usaActiveSoft": true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.empresas = response.data
          }
        })
      },

      async carregaConsumidores (empresaId) {
        let url = ''
        this.tabela.conteudo = []
        this.isLoading = true
        this.tabela.carregamento = true
        // Para usuários ADMIN, pega o subdomínio da empresa selecionada
        if (this.user.tipo == 'ADMIN' && this.empresaSelecionada) {
          const empresaEncontrada = this.empresas.find(e => e.id === this.empresaSelecionada)
          this.subdominioSelecionado = empresaEncontrada ? empresaEncontrada.subdominio : null
        } else {
          // Para usuários não-ADMIN, pega o subdomínio da empresa do usuário logado
          this.subdominioSelecionado = this.companyobj.subdominio || null
        }

        if (empresaId) {
          url = baseApiUrl + 'Consumidores?filter={"where":{"empresaId":"' + empresaId + '"}}&access_token=' + sessionStorage.getItem('accToken')
        } else {
          url = baseApiUrl + 'Consumidores?filter={"where":{"empresaId":"' + this.user.empresaId + '"}}&access_token=' + sessionStorage.getItem('accToken')
        }

        await axios.get(url)
        .then(response => {
          if (response.data) {
            this.tabela.conteudo = response.data
            this.tabela.carregamento = false
          }
          this.isLoading = false
        })
      },

      editItem (item) {
        this.isLoading = true
        this.editedIndex = this.tabela.conteudo.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.editedItem.empresaId = this.user.tipo == 'ADMIN' ? this.empresaSelecionada : this.user.empresaId
        this.dialogoConsumidor = true
        this.isLoading = false
      },

      async salvarConsumidor() {
        var vm = this;
        if (this.editedItem.nome || this.editedItem.email || this.editedItem.password || this.editedItem.tipo || this.editedItem.lojistaId) {
          this.isLoading = true
          this.editedItem.empresaId = this.user.tipo == 'ADMIN' ? this.empresaSelecionada : this.companyobj.id
          this.editedItem.matricula = this.editedItem.matricula.trim()

          await axios.post(baseApiUrl + 'Consumidores/novoConsumidor?access_token=' + sessionStorage.getItem('accToken'), this.editedItem)
          .then(response => {
            if (response.data) {
              this.isLoading = false
              this.dialogoConsumidor = false
              vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "INFORMAÇÃO")
              this.carregaConsumidores(this.user.tipo == 'ADMIN' ? this.empresaSelecionada : this.companyobj.id)
            }
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack("red", "Erro ao realizar operação", "DESCULPE")
          })
        } else {
          vm.$refs.chamaSnackbar.snack("orange", "Preencha os campos para prosseguir", "ATENÇÃO")
        }
      },

      async reenviarSenha(item) {
        let vm = this
        var r = confirm('Deseja reenviar a senha para o usuário ' + item.nome + '?')
        if (r == true) {
          this.isLoading = true
          await axios.post(baseApiUrl + 'Consumidores/msgRecuperaSenha', {"matricula": item.matricula})
          .then(response => {
            if (response.data) {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#0288D1","Mensagem enviada com a senha para o WhatsApp do responsável","INFORMAÇÃO")
            }
          })
        }
      },
      async reenviarBoasVindas(item) {
        let vm = this
        var r = confirm('Deseja reenviar a mensagem de boas-vindas para o usuário ' + item.nome + '?')
        if (r == true) {
          this.isLoading = true
          await axios.post(baseApiUrl + 'Consumidores/msgBoasVindas?access_token=' + sessionStorage.getItem('accToken'), {"matricula": item.matricula})
          .then(response => {
            if (response.data) {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#0288D1","Mensagem de boas-vindas enviada para o WhatsApp do responsável","INFORMAÇÃO")
            }
          })
        }
      },

      async editarConsumidor() {
        var vm = this;
        if (this.editedItem.nome || this.editedItem.cpf || this.editedItem.senha || this.editedItem.dataNascimento || this.editedItem.matricula || this.editedItem.curso || this.editedItem.turma || this.editedItem.whatsApp || this.editedItem.responsavel) {
          this.isLoading = true

          await axios.post(baseApiUrl + 'Consumidores/novoConsumidor?access_token=' + sessionStorage.getItem('accToken'), this.editedItem)
          .then(response => {
            if (response.data) {
              this.isLoading = false
              this.dialogoConsumidor = false
              vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "INFORMAÇÃO")
              this.carregaConsumidores(this.user.tipo == 'ADMIN' ? this.empresaSelecionada : this.companyobj.id)
            }
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack("red", "Erro ao realizar operação", "DESCULPE")
          })
        } else {
          vm.$refs.chamaSnackbar.snack("orange", "Preencha os campos para prosseguir", "ATENÇÃO")
        }
      },

      async capturarFoto() {
        this.editedItem.hashBase64 = await this.$refs.camera.capturar();
        this.dialogoCamera = false
      },

      inputFilter(newFile, oldFile, prevent) {
        if (newFile && !oldFile) {
          // Before adding a file
          // Filter system files or hide files
          if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
            return prevent()
          }
          // Filter php html js file
          if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
            return prevent()
          }
        }
      },

      inputFileRg1(newFile, oldFile) {
        if (newFile && !oldFile) {
          var reader = new FileReader()
          var file = this.filesRg1[0]

          //salva a base64 na variável
          reader.onloadend = function() {
            document.getElementById('foto').value = reader.result
          };

          setTimeout(() => {
            this.editedItem.hashBase64 = document.getElementById('foto').value
          }, 500);

          //Gera base64
          reader.readAsDataURL(file.file);
        }

        if (newFile && oldFile) {
          // update
        }

        if (!newFile && oldFile) {
          // remove
        }
      },

      async abreLeituraQRCode() {
        var vm = this;
        if (this.valorTransacao == '0,00') {
          vm.$refs.chamaSnackbar.snack("#F9A825","Informe um valor para continuar!","ATENÇÃO")
        } else if (parseFloat(this.valorTransacao.replace(',','.')) < 1) {
          vm.$refs.chamaSnackbar.snack("#F9A825","Valor mínimo para recargas é de R$ 1,00","ATENÇÃO")
        } else {
          this.dialogoValorTransacao = false

        this.empresaSelecionada = this.user.tipo == 'ADMIN' ? this.empresaSelecionada : this.user.empresaId

          await axios.get(baseApiUrl + 'Empresas?filter={"where":{"id":"' + this.empresaSelecionada + '"}, "fields":{"gatewayPagamentoPix": true}}&access_token=' + sessionStorage.getItem('accToken'))
          .then(response => {
            this.gatewayPagamento = response.data[0].gatewayPagamentoPix
            if (response.data[0].gatewayPagamentoPix == 'ASAAS') {
              this.pagarPixAsaas()
            } else if (response.data[0].gatewayPagamentoPix == 'TAPAGO') {
              this.pagarPixTaPago()
            } else if (response.data[0].gatewayPagamentoPix == 'SICOOB') {
              this.pagarPixSicoob();
            }
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack("red","Erro ao buscar o informações de pagamento","ATENÇÃO")
          });
        }
      },

      async pagarPixAsaas() {
        var vm = this
        this.isLoading = true
        this.cobrancaAsaas.value = parseFloat(this.valorTransacao.replace(',','.'))
        this.cobrancaAsaas.dueDate = moment().format('YYYY-MM-DD')
        if (this.codigoInscricao) {
          this.cobrancaAsaas.qrCode = this.codigoInscricao
          this.cobrancaAsaas.description = 'Referente a recarga do cartão de consumo nº ' + this.codigoInscricao + ' no AIConsumer'
        } else {
          this.cobrancaAsaas.qrCode = this.codigoQrCode
          this.cobrancaAsaas.description = 'Referente a recarga do cartão de consumo nº ' + this.codigoQrCode + ' no AIConsumer'
        }
        this.cobrancaAsaas.empresaId = this.consumidor.empresaId

        await axios.post(baseApiUrl + 'Pagamentos/AsaasCobranca', this.cobrancaAsaas)
        .then(response => {
          if (response.data) {
            this.isLoading = false
            this.cobrancaPix.id = response.data.paymentId
            this.cobrancaPix.qrCode = "data:image/jpeg;base64," + response.data.qrCode.encodedImage
            this.cobrancaPix.chaveCopiaCola = response.data.qrCode.payload
            this.dialogoPagamentoPix = true
            this.consultaPagamentoPixAsaas()
          }
        })
          .catch(() => {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#EF5350",
              "Problema ao criar transação, tente novamente",
              "DESCULPE"
            );
          });
      },

      async consultaPagamentoPixAsaas() {
        this.verificaPagamento = setInterval(async function() {
          await axios.post(baseApiUrl + 'Pagamentos/AsaasCobrancaConsulta', {"paymentId": this.cobrancaPix.id}).then(async response => {
            if (response.data.status == 'RECEIVED') {
              clearInterval(this.verificaPagamento)
              if (this.codigoInscricao) {
                this.saldoCartao = await this.validaQrCode(this.codigoInscricao, 'saldo')
              } else {
                this.saldoCartao = await this.validaQrCode(this.codigoQrCode, 'saldo')
              }
              this.dialogoPagamentoPix = false
              this.dialogoConfirmacao = true
            }
          })
        }.bind(this), 5000)
      },

      async pagarPixTaPago() {
        var vm = this
        this.isLoading = true
        let dados = {
          "qrCode": "",
          "valor": parseFloat(this.valorTransacao.replace(',','.')),
          "descricao": "",
          "empresaId": this.consumidor.empresaId,
        }

        if (this.codigoInscricao) {
          dados.qrCode = this.codigoInscricao
          dados.descricao = 'Referente a recarga do cartão de consumo nº ' + this.codigoInscricao + ' no AIConsumer'
        } else {
          dados.qrCode = this.codigoQrCode
          dados.descricao = 'Referente a recarga do cartão de consumo nº ' + this.codigoQrCode + ' no AIConsumer'
        }

        await axios.post(baseApiUrl + 'Pagamentos/taPagoCobranca', dados)
        .then(response => {
          if (response.data) {
            this.cobrancaPix.id = response.data.transactionId
            this.cobrancaPix.qrCode = "data:" + response.data.instantPayment.generateImage.mimeType + ";base64," + response.data.instantPayment.generateImage.imageContent
            this.cobrancaPix.chaveCopiaCola = response.data.instantPayment.textContent
            this.dialogoPagamentoPix = true
            this.isLoading = false
            this.consultaPagamentoPixTaPago()
          }
        })
        .catch(() => {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao criar transação, tente novamente","DESCULPE")
        })
      },

      async consultaPagamentoPixTaPago() {
        this.verificaPagamento = setInterval(async function() {
          await axios.post(baseApiUrl + 'Pagamentos/taPagoCobrancaConsulta', {"paymentId": this.cobrancaPix.id})
          .then(async response => {
            if (response.data.status == 'APPROVED') {
              clearInterval(this.verificaPagamento)
              if (this.codigoInscricao) {
                this.saldoCartao = await this.validaQrCode(this.codigoInscricao, 'saldo')
              } else {
                this.saldoCartao = await this.validaQrCode(this.codigoQrCode, 'saldo')
              }
              this.dialogoPagamentoPix = false
              this.dialogoConfirmacao = true
            }
          })
        }.bind(this), 5000)
      },

      async pagarPixSicoob() {
        this.isLoading = true;

        let dados = {
          empresaId: this.user.tipo == 'ADMIN' ? this.empresaSelecionada : this.user.empresaId,
          qrCode: await this.pegaQRCode(this.editedItem.id),
          calendario: {
            expiracao: 3600
          },
          devedor: {
            cpf: this.editedItem.cpf.replace(/[^\d]/g, ''),
            nome: this.editedItem.nome,
          },
          valor: {
            original: parseFloat(this.valorTransacao.replace(",", ".")),
          },
          chave: "",
          solicitacaoPagador: "Referente a recarga do cartão de consumo nº " + this.editedItem.matricula + " no AIConsumer",
        };

        await axios.post(baseApiUrl + "Pagamentos/sicoobCobranca", dados)
        .then(response => {
          if (response.data) {
            this.cobrancaPix.id = response.data.txid
            this.cobrancaPix.qrCode = response.data.brcode
            this.cobrancaPix.chaveCopiaCola = response.data.brcode
            this.dialogoPagamentoPix = true;
            this.isLoading = false;
            this.consultaPagamentoPixSicoob(dados.qrCode);
          }
        })
        .catch(() => {
          this.isLoading = false;
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao criar transação, tente novamente", "DESCULPE");
        });
      },

      async consultaPagamentoPixSicoob(qrCode) {
        try {
          this.verificaPagamento = setInterval(
            async function () {
              await axios.post(baseApiUrl + "Pagamentos/sicoobCobrancaConsulta", {"paymentId": this.cobrancaPix.id})
              .then(async res3 => {
                if (res3.data.status == "APPROVED") {
                  clearInterval(this.verificaPagamento);

                  if (this.editedItem.matricula) {
                    this.saldoCartao = await this.validaQrCode(qrCode, "saldo");
                  }
                  else {
                    this.saldoCartao = await this.validaQrCode(qrCode, "saldo");
                  }

                  this.dialogoPagamentoPix = false;
                  this.dialogoConfirmacao = true;
                }
              });
            }.bind(this), 5000);
        } catch (error) {
          clearInterval(this.verificaPagamento);
          this.isLoading = false;
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Não foi possível verificar o pagamento, tente novamente!", "DESCULPE");
        }
      },

      async validaQrCode(qrCode, atributo) {
        let resultado
        await axios.post(baseApiUrl + 'QRCodes/validaQrcode', {"qrCode": qrCode})
        .then(response => {
          if (response.data) {
            resultado = response.data[atributo]
          }
        })
        return resultado
      },

      closeDialog(reload = false) {
        this.dialogoConfirmacao = false
        this.dialogoPagamentoPix = false
        if (reload) {
          window.location.reload()
        }
      },

      async pegaQRCode(id) {
        try {
            const response = await axios.get(`${baseApiUrl}CartoesConsumo?filter={"where":{"consumidorId":"${id}"}}&access_token=${sessionStorage.getItem('accToken')}`);
            const qrCode = response.data[0].qrCode;
            return qrCode;
        } catch (error) {
            // console.error("Erro ao buscar QR Code:", error);
            return null;
        }
      },

      empresaIdAdmin() {
        return this.user.tipo === 'ADMIN' ? this.empresaSelecionada : this.companyobj.id
      },

      formatarValorApiReais(val) {
        if (val == null || val === '') return null
        const s = String(val).trim().replace(/\s/g, '')
        const n = parseFloat(s.replace(/\./g, '').replace(',', '.'))
        if (isNaN(n) || n < 0) return null
        return n.toFixed(2).replace('.', ',')
      },

      async abrirDialogoAdminAjusteSaldo(item) {
        this.adminSaldo.loading = true
        this.adminSaldo.consumidorNome = item.nome
        this.adminSaldo.operacao = 'ACRESCENTAR'
        this.adminSaldo.valorStr = ''
        this.adminSaldo.motivo = ''
        this.adminSaldo.cartaoId = ''
        try {
          const filt = encodeURIComponent(JSON.stringify({ where: { consumidorId: item.id } }))
          const r = await axios.get(`${baseApiUrl}CartoesConsumo?filter=${filt}&access_token=${sessionStorage.getItem('accToken')}`)
          if (!r.data || !r.data.length) {
            this.$refs.chamaSnackbar.snack('#EF5350', 'Cartão não encontrado para este consumidor.', 'ERRO')
            return
          }
          this.adminSaldo.cartaoId = r.data[0].id
          this.dialogoAdminAjusteSaldo = true
        } catch (e) {
          this.$refs.chamaSnackbar.snack('#EF5350', 'Erro ao buscar cartão.', 'ERRO')
        } finally {
          this.adminSaldo.loading = false
        }
      },

      async executarAdminAjusteSaldo() {
        const valor = this.formatarValorApiReais(this.adminSaldo.valorStr)
        if (!valor) {
          this.$refs.chamaSnackbar.snack('#F9A825', 'Informe um valor válido.', 'ATENÇÃO')
          return
        }
        this.adminSaldo.loading = true
        try {
          await axios.post(
            `${baseApiUrl}CartoesConsumo/adminSaldoCartao?access_token=${sessionStorage.getItem('accToken')}`,
            {
              tipoOperacao: 'AJUSTE',
              empresaId: this.empresaIdAdmin(),
              cartaoConsumoId: this.adminSaldo.cartaoId,
              operacao: this.adminSaldo.operacao,
              valor,
              motivo: this.adminSaldo.motivo || '',
            }
          )
          this.dialogoAdminAjusteSaldo = false
          this.$refs.chamaSnackbar.snack('green', 'Saldo ajustado com sucesso.', 'SUCESSO')
        } catch (err) {
          const msg = (err.response && err.response.data && err.response.data.error && err.response.data.error.message) || 'Erro ao ajustar saldo'
          this.$refs.chamaSnackbar.snack('#EF5350', msg, 'ERRO')
        } finally {
          this.adminSaldo.loading = false
        }
      },

      async abrirDialogoAdminTransferenciaSaldo(item) {
        this.adminTransf.loading = true
        this.adminTransf.origemConsumidorId = item.id
        this.adminTransf.consumidorOrigem = item.nome
        this.adminTransf.destConsumidorId = ''
        this.adminTransf.valorStr = ''
        this.adminTransf.motivo = ''
        this.adminTransf.cartaoOrigemId = ''
        try {
          const filt = encodeURIComponent(JSON.stringify({ where: { consumidorId: item.id } }))
          const r = await axios.get(`${baseApiUrl}CartoesConsumo?filter=${filt}&access_token=${sessionStorage.getItem('accToken')}`)
          if (!r.data || !r.data.length) {
            this.$refs.chamaSnackbar.snack('#EF5350', 'Cartão de origem não encontrado.', 'ERRO')
            return
          }
          this.adminTransf.cartaoOrigemId = r.data[0].id
          this.dialogoAdminTransferenciaSaldo = true
        } catch (e) {
          this.$refs.chamaSnackbar.snack('#EF5350', 'Erro ao buscar cartão.', 'ERRO')
        } finally {
          this.adminTransf.loading = false
        }
      },

      async executarAdminTransferenciaSaldo() {
        const valor = this.formatarValorApiReais(this.adminTransf.valorStr)
        if (!valor) {
          this.$refs.chamaSnackbar.snack('#F9A825', 'Informe o valor da transferência.', 'ATENÇÃO')
          return
        }
        if (!this.adminTransf.destConsumidorId) {
          this.$refs.chamaSnackbar.snack('#F9A825', 'Selecione o consumidor de destino.', 'ATENÇÃO')
          return
        }
        this.adminTransf.loading = true
        try {
          const filtDest = encodeURIComponent(JSON.stringify({ where: { consumidorId: this.adminTransf.destConsumidorId } }))
          const rDest = await axios.get(`${baseApiUrl}CartoesConsumo?filter=${filtDest}&access_token=${sessionStorage.getItem('accToken')}`)
          if (!rDest.data || !rDest.data.length) {
            this.$refs.chamaSnackbar.snack('#EF5350', 'Cartão do destino não encontrado.', 'ERRO')
            return
          }
          const cartaoDestinoId = rDest.data[0].id
          await axios.post(
            `${baseApiUrl}CartoesConsumo/adminSaldoCartao?access_token=${sessionStorage.getItem('accToken')}`,
            {
              tipoOperacao: 'TRANSFERENCIA',
              empresaId: this.empresaIdAdmin(),
              cartaoOrigemId: this.adminTransf.cartaoOrigemId,
              cartaoDestinoId,
              valor,
              motivo: this.adminTransf.motivo || '',
            }
          )
          this.dialogoAdminTransferenciaSaldo = false
          this.$refs.chamaSnackbar.snack('green', 'Transferência concluída.', 'SUCESSO')
        } catch (err) {
          const msg = (err.response && err.response.data && err.response.data.error && err.response.data.message) || (err.response && err.response.data && err.response.data.error && err.response.data.error.message) || 'Erro na transferência'
          this.$refs.chamaSnackbar.snack('#EF5350', msg, 'ERRO')
        } finally {
          this.adminTransf.loading = false
        }
      },

      doCopy(id) {
        try {
          let copyText = document.getElementById(id);
          copyText.select();
          copyText.setSelectionRange(0, 99999); /* Para dispositivos móveis */
          document.execCommand("copy");
          this.snackbar = true
          this.textoSnackbar = 'Chave copiada para a área de transferência!'
        } catch (error) {
          this.snackbar = true
          this.textoSnackbar = 'Problema ao copiar chave para a área de transferência'
        }
      },

      async deleteItem(item) {
        var vm = this;
        var r = confirm('Deseja realmente excluir o consumidor ' + item.nome + '?');
        if (r == true) {
          this.isLoading = true;
          await axios.delete(baseApiUrl + 'Consumidores/' + item.id + '?access_token=' + sessionStorage.getItem('accToken'))
            .then(() => {
              this.isLoading = false;
              vm.$refs.chamaSnackbar.snack('success', 'Consumidor excluído com sucesso!', 'INFORMAÇÃO');
              this.carregaConsumidores(this.user.tipo == 'ADMIN' ? this.empresaSelecionada : this.companyobj.id);
            })
            .catch(() => {
              this.isLoading = false;
              vm.$refs.chamaSnackbar.snack('red', 'Erro ao excluir consumidor', 'DESCULPE');
            });
        }
      },

      async copiarTexto(texto) {
        this.mensagemCopiado = true
        await navigator.clipboard.writeText(texto)

        setTimeout(() => {
          this.mensagemCopiado = false
        }, 3000);
      },

      async atualizarConsumidores() {
        let vm = this
        this.isLoading = true
        const empresaId = this.empresaSelecionada 

         await axios.post(baseApiUrl + 'ServicesActiveSoft/atualizarConsumidores?access_token=' + sessionStorage.getItem('accToken'), {"empresaId": empresaId})
          .then(response => {
            this.isLoading = false
            if (response.data && !response.data.erro) {
              const dados = response.data.dados || response.data
              this.$refs.chamaSnackbar.snack("green", `Atualização concluída! ${dados.consumidoresCriados || "Zero"} consumidores criados, ${dados.consumidoresAtualizados || "Zero"} consumidores atualizados.`, "SUCESSO")
              this.carregaConsumidores(empresaId)
            } else if (response.data && response.data.erro) {
              this.$refs.chamaSnackbar.snack("red", response.data.mensagem || "Erro ao atualizar consumidores", "DESCULPE")
            }
          })
          .catch(() => {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack('red', 'Erro ao atualizar consumidores', 'DESCULPE');
          });
      },

      obterTurmasUnicas(lista) {
        if (!Array.isArray(lista)) return []

        const turmasUnicas = new Set()

        lista.forEach(item => {
          if (item.turma) {
            turmasUnicas.add(item.turma.trim())
          }
        })

        return Array.from(turmasUnicas).sort((a, b) => 
          a.localeCompare(b, 'pt-BR')
        )
      },

      remove (item) {
        const index = this.transferencia.turmasSelecionadas.indexOf(item)
        if (index >= 0) this.transferencia.turmasSelecionadas.splice(index, 1)
      },

      async transferirAlunos() {
        let vm = this

        if (this.transferencia.turmasSelecionadas.length == 0) {
          vm.$refs.chamaSnackbar.snack("orange", "Selecione ao menos uma turma para prosseguir", "ATENÇÃO")
          return
        }

        if (!this.transferencia.empresaSelecionada) {
          vm.$refs.chamaSnackbar.snack("orange", "Selecione uma empresa para prosseguir", "ATENÇÃO")
          return
        }

        this.isLoading = true
        let turmasSet = new Set(this.transferencia.turmasSelecionadas.map(t => t.trim()))
        let consumidoresIds = this.tabela.conteudo.filter(aluno => turmasSet.has(aluno.turma.trim())).map(aluno => aluno.id)

        let dados = {
          listaConsumidorId: consumidoresIds,
          novaEmpresaId: this.transferencia.empresaSelecionada
        }

        await axios.post(baseApiUrl + 'Consumidores/transferencia?access_token=' + sessionStorage.getItem('accToken'), dados)
        .then(response => {
          this.dialogoTransferencia = false
          vm.$refs.chamaSnackbar.snack("green", "Transferência realizada! " + response.data.mensagem, "INFORMAÇÃO")
          this.carregaConsumidores(this.user.tipo == 'ADMIN' ? this.empresaSelecionada : this.companyobj.id)
        })
        .catch(() => {
          vm.$refs.chamaSnackbar.snack("red", "Problema ao transferir alunos. Tente novamente.", "DESCULPE")
        })

        this.isLoading = false
      },
    },
    directives: {money: VMoney}
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #424f4e;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px; width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
  }

  span.v-stepper__step__step.primary {
    background-color: #009B99!important;
    border-color: #009b9b!important;
  }

  .theme--light.v-stepper .v-stepper__label {
    color: #009B99;
  }

  .theme--light.v-stepper .v-stepper__step--complete .v-stepper__label {
    color: #009B99;
  }

  /* Evita quebra “no meio” de CPF, WhatsApp, etc.; tabela rola na horizontal se precisar */
  .consumidores-table .v-data-table__wrapper {
    overflow-x: auto;
  }

  .consumidores-table .consumidor-cell-nowrap {
    white-space: nowrap !important;
    vertical-align: middle;
  }

  .consumidores-table .consumidor-cell-acoes {
    white-space: nowrap !important;
    vertical-align: middle;
  }

  .consumidores-table .consumidor-cell-turma,
  .consumidores-table .consumidor-cell-curso {
    white-space: nowrap !important;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 260px;
    vertical-align: middle;
  }

  .consumidores-table .consumidor-cell-responsavel {
    white-space: nowrap !important;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 240px;
    vertical-align: middle;
  }
</style>
